export interface ListHelpConfig {
  page_key: string;
  page_title?: string;
  button_text?: string;
  modal_title?: string;
  help_content: string;
}

export const DEFAULT_LIST_HELP_CONFIGS: ListHelpConfig[] = [
  {
    page_key: 'trademark_monitor',
    page_title: '商标监控',
    button_text: '通知帮助',
    modal_title: '商标状态通知排查说明',
    help_content: `<ol>
<li>
<p><strong>先确认任务是否真的进入通知链路</strong></p>
<p>到系统日志或邮件日志搜索：商标状态发生变更、商标状态通知任务已派发、开始执行商标状态通知任务。</p>
</li>
<li>
<p><strong>如果任务被跳过，先检查商标基础数据</strong></p>
<p>当前通知任务要求商标至少有 <code>name</code>、<code>application_no</code>、<code>status</code>。只要其中任意一个为空，就会记录“商标数据不完整，跳过通知”，并且不会发送邮件。</p>
</li>
<li>
<p><strong>再检查模板和收件人</strong></p>
<p>如果日志里出现“未找到商标状态通知模板”，说明新状态没有匹配到模板；如果出现“没有收件人，跳过通知”，说明当前商标没有可发送的通知邮箱。</p>
</li>
<li>
<p><strong>如果任务执行了但仍没收到邮件</strong></p>
<p>继续搜索：发送商标状态通知邮件失败、商标状态通知发送失败。一般可以看到 SMTP 拒收、邮箱不存在等具体原因。</p>
</li>
</ol>`,
  },
];

export const get_default_list_help_config = (page_key: string): ListHelpConfig | undefined => {
  return DEFAULT_LIST_HELP_CONFIGS.find((item) => item.page_key === page_key);
};

export const merge_list_help_configs = (configs: Partial<ListHelpConfig>[]): ListHelpConfig[] => {
  const merged = new Map<string, ListHelpConfig>();

  DEFAULT_LIST_HELP_CONFIGS.forEach((item) => {
    merged.set(item.page_key, item);
  });

  configs.forEach((item) => {
    if (!item.page_key) {
      return;
    }

    const existing_item = merged.get(item.page_key);

    merged.set(item.page_key, {
      ...(existing_item || {
        page_key: item.page_key,
        help_content: '',
      }),
      ...item,
      page_key: item.page_key,
    });
  });

  return Array.from(merged.values());
};
